import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { Constants } from 'app/shared/constant/constants';
import { AddOnOrderService } from '../../services/add-on-order.service';


@Component({
  selector: 'add-on-order-list',
  templateUrl: './add-on-order-list.component.html',
  styleUrls: ['./add-on-order-list.component.scss'],
})
export class AddOnOrderListComponent implements OnInit {


  public orderType: string;
  public orderList: any = [];
  public noDataFound: boolean = true;
  public showLoader: boolean = false;

  
  constructor(
    private addOnOrderService: AddOnOrderService,
    public router: Router,
    private route: ActivatedRoute,
    public toast: ToastrService,
    public modalService :NgbModal
  ) {

  }

  ngOnInit(): void {

    this.route.params.subscribe((params: Params) => {
      this.orderType = params['orderType'];
        this.getOrderList();
    });

  }



  getOrderList() {
    if(this.orderType == "esim") {
       this.addOnOrderService.getEsimOrderList().subscribe(resp => {
          this.orderList = resp.body;
          if(this.orderList.length > 0) {
            this.noDataFound = false;
          }
       }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
       });
    } else if(this.orderType == "lounge") {
      this.addOnOrderService.getLoungeOrders().subscribe(resp => {
        this.orderList = resp.body;
        if(this.orderList.length > 0) {
          this.noDataFound = false;
        }
      }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
       });
    } else if(this.orderType == "xplorer") {
      this.addOnOrderService.getXplorerCardOrdersList().subscribe(resp => {
        let orderData: any = resp.body;
        this.orderList = orderData?.orders;
        this.noDataFound = false;
      }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
       });
    }

  }

  goToOrderDetails(orderId) {
    this.router.navigate(['/add-on/order-details', this.orderType, orderId]);
  }



}


